export default __webpack_public_path__ + "static/media/time.f4c7808a.svg";